<template>
  <div class="article-section">
    <h2 class="section-title">{{ title }}</h2>

    <div class="news-grid">
      <ArticleMainCard
        v-for="item in items"
        :key="item.id"
        :slug="item.slug"
        :name="item.name"
        :image="item.image"
        :published-at="item.publicationDate"
        :link="item.link"
      />
    </div>

    <div class="section-divider"></div>

    <div v-if="showViewAll" class="view-all-container">
      <BaseButton
        name="Смотреть всё"
        theme="qiwi"
        theme-type="outline"
        size="l"
        border-radius="big"
        icon-right="arrow/arrow-circle-right"
        class="view-all-button"
        @click="$emit('view-all')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'
  import ArticleMainCard from './ArticleMainCard.vue'
  import type { ArticleMainItem } from '~/models/articles'

  defineProps<{
    title: string
    items: ArticleMainItem[]
    showViewAll?: boolean
  }>()

  defineEmits<{
    (e: 'view-all'): void
  }>()
</script>

<style lang="scss" scoped>
  .article-section {
    @extend %flex-column;

    gap: 24px;
    width: 100%;
    margin-bottom: 52px;
    margin-top: 35px;

    @include vp-767 {
      gap: 20px;
      margin-bottom: 40px;
    }

    > .section-title {
      font-weight: 500;
      font-size: 32px;
      line-height: 1.25;
      color: $color-default-black;
      margin: 0;

      @include vp-767 {
        font-size: 24px;
      }
    }

    > .news-grid {
      display: flex;
      gap: 16px;
      width: 100%;

      @include vp-1279 {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
      }

      @include vp-767 {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }

    > .section-divider {
      width: 100%;
      height: 2px;
      background-color: $color-potato-10;

      @include vp-767 {
        margin: 20px 0;
      }
    }

    > .view-all-container {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
</style>
